import React, { useState, useEffect } from "react";
import { Link, useParams} from 'react-router-dom';
import { useSelector } from "react-redux";
import { getBrands } from '../../helpers/listsApi';
import { api } from '../../api';
import { toast } from "react-toastify";
import { isEmptyObject } from "jquery";

const ViewAdminAgents = props => {
    const token = useSelector((state) => state.auth.token);
    // eslint-disable-next-line
    const [brands, setBrands] = useState([])
    const [adminData, setAdminData] = useState({});
    const [adminDataRegion, setAdminDataRegion] = useState({});
    const { id: row_id } = useParams(); 

    useEffect(() => {
        getBrands({},token).then(res => {
            setBrands(res);
        })
    }, [token])

    const status = [
        { value: true, label: "Active" },
        { value: false, label: "Inactive" }
    ]

    useEffect(() => {
        api.users
            .getUserByID({ usersId: row_id },token)
            .then((res) => {
                if (res.success === false) {
                    toast.error(res.message);
                }
                setAdminData(res.user)
                 setAdminDataRegion(
                    res.regions.map(region => ({
                    value: region.id,
                    label: region.name
                    }))
                );
       
            })
            .catch((err) => {
                 toast.error("Something went wrong");
                console.log(err)
            }
            );
    }, [row_id,token])

    // eslint-disable-next-line
    const getCurrentBrand = (brands) => {
        const data = brands.find(list => {
            return list.value === adminData.usersBrand 
        })
        if (!isEmptyObject(data)) {
            return data.label
        }
    }
// eslint-disable-next-line
    const getCurrentStatus = (value, list) => {
        const currentValue = list.find(lst => lst.value === value)
        return currentValue
    }

    return (

        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="box-row">
                        <div className="table-head">
                            <h1 className="sec-header">VIEW AGENT</h1>
                        </div>
                        <div className="card">
                            <div className="card-body box-row">

                                {/* <h1 className="section-header float-left">Admin Details</h1> */}

                                <div style={{ position: 'absolute', top: '0px', right: '15px' }}>
                                    <Link to={`/edit-agent/${row_id}`}>
                                        <button className="btn mt-3 submit-btn" variant="primary" type="submit"> Edit </button>
                                    </Link>
                                </div>

                                <div style={{ margin: '0px 50px' }}>
                                    <div className="form-group row col-md-8">
                                        <div className="col-md-3"><span><b>User Name</b>{' '}:</span></div>
                                        <div className="col-md-5"><span>{adminData.usersUserName}</span></div>
                                    </div>

                                    <div className="form-group row col-md-8">
                                        <div className="col-md-3"><span><b>Phone</b>{' '}:</span></div>
                                        <div className="col-md-5"><span>{adminData.usersPhone}</span></div>
                                    </div>
                                    
                                <div className="form-group row col-md-8">
                                    <div className="col-md-3"><span><b>Email</b>{' '}:</span></div>
                                    <div className="col-md-5"><span>{adminData.usersEmail}</span></div>
                                </div>

                                <div className="form-group row col-md-8">
                                    <div className="col-md-3"><span><b>Agent Name</b>{' '}:</span></div>
                                    <div className="col-md-5"><span>{adminData.usersName}</span></div>
                                </div>

                                {/* <div className="form-group row col-md-8">
                                    <div className="col-md-3"><span><b>Brand</b>{' '}:</span></div>
                                    <div className="col-md-5"><span>{getCurrentBrand(brands)}</span></div>
                                </div> */}

                                <div className="form-group row col-md-8">
                                    <div className="col-md-3"><span><b>User Status</b>{' '}:</span></div>
                                    <div className="col-md-5"><span>{Object.keys(status).length && adminData.usersStatus === true ? 'Active' : 'Inactive'}</span></div>
                                </div>

                                <div className="form-group row col-md-8">
                                    <div className="col-md-3"><span><b>Regions</b>{' '}:</span></div>
                                    <div className="col-md-5"><span>
                                         {adminDataRegion && adminDataRegion.length > 0
        ? adminDataRegion.map(r => r.label).join(', ')
        : 'N/A'}
                                        </span></div>
                                </div>

                             
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )


}
export default ViewAdminAgents;
